import SignatureIcon from "@static/core/icons/icon-signature.svg?react";
import StopIcon from "@static/core/icons/icon-stop.svg?react";
import SoonExpiredIcon from "@static/core/icons/icon-soon-expired.svg?react";
import ExpiredIcon from "@static/core/icons/icon-expired.svg?react";
import RocketIcon from "@static/core/icons/icon-rocket.svg?react";
import DeleteIcon from "@static/core/icons/icon-delete.svg?react";
import ArrayIcon from "@static/core/icons/icon-array.svg?react";
import i18n from "@/utils/i18n/i18n";

export type ShortcutEnumValueType = {
  label: string;
  icon: JSX.Element;
  indicator: string;
};

export const SHORTCUTS_ENUM: {
  [key: string]: ShortcutEnumValueType;
} = {
  waitingForMySignature: {
    label: i18n.t("home.dashboard.shortcuts.waitingForMySignature"),
    icon: <SignatureIcon />,
    indicator: "10",
  },
  collectionStopped: {
    label: i18n.t("home.dashboard.shortcuts.collectionStopped"),
    icon: <StopIcon />,
    indicator: "",
  },
  collectionSoonExpired: {
    label: i18n.t("home.dashboard.shortcuts.collectionSoonExpired"),
    icon: <SoonExpiredIcon />,
    indicator: "",
  },
  collectionExpired: {
    label: i18n.t("home.dashboard.shortcuts.collectionExpired"),
    icon: <ExpiredIcon />,
    indicator: "",
  },
  waitingForLaunch: {
    label: i18n.t("home.dashboard.shortcuts.waitingForLaunch"),
    icon: <RocketIcon />,
    indicator: "30",
  },
  collectionSoonPurged: {
    label: i18n.t("home.dashboard.shortcuts.collectionSoonPurged"),
    icon: <DeleteIcon />,
    indicator: "20",
  },
  myDashboard: {
    label: i18n.t("home.dashboard.shortcuts.myDashboard"),
    icon: <ArrayIcon />,
    indicator: "",
  },
};
